import React, { useState } from 'react';
import Icon from './icons';

interface SearchProps {
    query?: string;
    onSearch: (query: string) => void;
    onClear?: () => void;
}

const Search: React.FC<SearchProps> = ({ query = '', onSearch, onClear = ()=>{} }) => {
    const [_query, setQuery] = useState('');

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setQuery(event.target.value);
    };

    const handleSearch = (e:any) => {
        e.preventDefault();
        e.stopPropagation();
        onSearch(_query);
    };

    return (
        <form onSubmit={handleSearch} className="w-[17.736rem] flex  bg-[#F2F2F2] rounded-md border border-[#D9D9D9] h-[2.375rem]">
            <input
                type="search"
                value={_query}
                onChange={(e:any) => {
                    handleInputChange(e);
                    if (e.nativeEvent.inputType != 'deleteContentBackward' && e.target.value === '') {
                        onClear();
                        onSearch('');
                    } 
                  }}
                placeholder="Search..."
                className="px-2 flex-grow focus:outline-none bg-[#F2F2F2] text-black font-medium text-sm"
            />
            <button type='submit' className="w-[2.375rem] h-[2.375rem] flex items-center justify-center">
                <Icon name='search' size={1.45} className='text-gray-700' />
            </button>
        </form>
    );
};

export default Search;